import React, { ChangeEvent, useEffect, useMemo, useState } from "react";
import AdminDashboardLayout from "../../../Admin/commonComponents/DashboardLayout";
import TransactionsTable from "./components/TransactionsTable";

const Transactions: React.FC = () => {
  const [detailData, setDetailData] = useState<any>(null);
  const [filterState, setFilterState] = useState<any>({
    approved: false,
    pending: false,
    rejected: false,
  });

  useEffect(() => {
    /* const fetchData = async () => {
      const result: IAPIResponse | undefined = await getMyListingDetails(
        detailData
      );

      if (result) {
        const { data, count } = result;
        setFullDetailData(data);
      }
    }; */

    if (detailData) {
      // fetchData();
    }
  }, [detailData]);

  const onFilter = (evt: ChangeEvent<HTMLInputElement>, state: string) => {
    setFilterState({ ...filterState, [state]: evt.target.checked });
  };

  const showTable = useMemo(
    () => <TransactionsTable setDetailData={(value) => setDetailData(value)} />,
    []
  );

  return (
    <AdminDashboardLayout hasHeader searchPlaceholder="Search transactions">
      <div className="page-central">
        <div>{showTable}</div>
      </div>
    </AdminDashboardLayout>
  );
};

export default Transactions;
